export default function MySQL_TIMESTAMP() {
  return (
    <div>
      <h2>MySQL_TIMESTAMP</h2>    </div>
  );
}